import { useState } from 'react'

const IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif,image/avif'

export default function FilePicker({
  label = 'Choose file',
  accept = IMAGE_ACCEPT,
  onFile,
}: {
  label?: string
  accept?: string
  onFile: (file: File) => void
}) {
  const [fileName, setFileName] = useState('')

  return (
    <div>
      <label className="inline-flex cursor-pointer">
        <span className="text-caps inline-flex h-11 items-center bg-ink px-5 text-white hover:bg-rose">
          {label}
        </span>
        <input
          type="file"
          accept={accept}
          className="sr-only"
          onChange={(event) => {
            const file = event.target.files?.[0]
            if (file) {
              setFileName(file.name)
              onFile(file)
            }
            event.target.value = ''
          }}
        />
      </label>
      {fileName ? <p className="mt-2 text-[12px] text-copy">{fileName}</p> : null}
    </div>
  )
}
